{
  "version": 1,
  "asset_id": "63aa4187-9bf2-4547-b31b-f8848add0395",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/63aa4187-9bf2-4547-b31b-f8848add0395/silivri-hizli-elektrikci-7-24-dukkan-7.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/63aa4187-9bf2-4547-b31b-f8848add0395/silivri-hizli-elektrikci-7-24-dukkan-7.jpg",
  "original_filename": "silivri-hizli-elektrikci-7-24-dukkan-7.jpg",
  "size": 126315,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:26:55Z"
}
